import { addTranslation } from '../../_helpers/Translate';

addTranslation({
  ru: {
    monitoring_tables: 'Таблица',
    monitoring_charts: 'Диаграмма',
    monitoring_reportsVoucherHolders:'Отчеты по ваучеродержателям',
    monitoring_reportVoucherHoldersWaitingForPO:'Ваучеродержатели, ожидающие зачисления в ДО',
    monitoring_reportVoucherHoldersNotSelectPO:"Ваучеродержатели, не выбравшие ДО",
    monitoring_reportVoucherHoldersNotAcceptVoucher:'Заявители, не принявшие ваучер',
    monitoring_fromDate: 'дата с',
    monitoring_toDate: 'дата по',
    monitoring_service: 'Выберите услугу',
    monitoring_status: 'Выберите статус',
    monitoring_chartsStatus: 'Количество заявок в разрезе статусов, ед.',
    monitoring_chartsService: 'Количество заявок в разрезе услуг, ед.',
    monitoring_columnService: 'Наименование',
    monitoring_columnLocation: 'Населенный пункт',
    monitoring_columnSUBMITTED: 'Поступило',
    monitoring_columnIN_PROGRESS: 'В обработке',
    monitoring_columnREADY_FOR_SIGN: 'На подписи',
    monitoring_columnREADY_FOR_SIGN_POSITIVE: 'Ожидает подпись на положительный ответ',
    monitoring_columnREADY_FOR_SIGN_NEGATIVE: 'Ожидает подпись на отрицательный ответ',
    monitoring_columnIN_PROGRESS_IN_EXTERNAL_APP: 'Передано в ИС ОО',
    monitoring_columnCOMPLETED_POSITIVE: 'Положительно',
    monitoring_columnCOMPLETED_NEGATIVE: 'Отрицательно',
    monitoring_columnAllByRegion:'Всего по региону',
    monitoring_columnAllByStatus:'Всего по статусу',
    monitoring_columnParentIIN:'ИИН родителя',
    monitoring_columnChildIIN:'ИИН ребенка',
    monitoring_columnParentFullName:'ФИО родителя',
    monitoring_columnChildFullName:'ФИО ребенка',
    monitoring_columnBin:'БИН ДО',
    monitoring_columnKatoCode:'Като код',
    monitoring_columnLangName:"Наименование ДО",
    monitoring_columnParentTelephoneNumber:'Номер телефон родителя',
    monitoringDucks_errorLoadTable: 'Не удалось загрузить данные',
    monitoringDucks_errorExportTable: 'Не удалось экспортировать данные',
    monitoring_excelAllServices: 'Все услуги',
    monitoring_excelPeriod: 'Период: с {{period.fromDate}} - по {{period.toDate}}',
    monitoring_excelService: 'Услуга: {{service}}',
    monitoring_excel_sheet_title: 'Отчеты',
    monitoring_export_btn: 'Экспортировать',
    monitoring_report_btn: 'Загрузить отчет',

    // queued
    monitoring_queued_byGender: 'Очередники по году и полу',
    monitoring_queued_byPosition: 'Очередники по территориальной принадлежности',
    year_6_male: '6 лет, мужской',
    age_suffix:'г.',
    age_male:'г.,мужской',
    age_female:'г., женский',
    year_6_female: '6 лет, женский',
    year_5_male: '5 лет, мужской',
    year_5_female: '5 лет, женский',
    year_4_male: '4 лет, мужской',
    year_4_female: '4 лет, женский',
    year_3_male: '3 лет, мужской',
    year_3_female: '3 лет, женский',
    year_2_male: '2 лет, мужской',
    year_2_female: '2 лет, женский',
    year_1_male: '1 лет, мужской',
    year_1_female: '1 лет, женский',
    year_0_male: '0 лет, мужской',
    year_0_female: '0 лет, женский',
    from_2_to_6: 'от 2 до 6 лет',
    from_3_to_6: 'от 3 до 6 лет',

    region: 'Управление образования Алматинской области',
    territorial_affiliation: 'Территориальная принадлежность',
    total: 'Всего',
    age_1: '1 год',
    age_2: '2 года',
    age_3: '3 года',
    age_4: '4 года',
    age_5: '5 лет',
    age_6: '6 лет',
    rural_area: 'сельская местность',
    urban_area: 'городская местность'
  },
  kk: {
    monitoring_tables: 'Кесте',
    monitoring_charts: 'Диаграмма',
    monitoring_reportsVoucherHolders: 'Ваучер ұстаушылар бойынша есептер',
    monitoring_reportVoucherHoldersWaitingForPO: 'Оқу ұйымына тіркелуді күтетін ваучер ұстаушылар',
    monitoring_reportVoucherHoldersNotSelectPO: 'Оқу ұйымын таңдамаған ваучер ұстаушылар',
    monitoring_reportVoucherHoldersNotAcceptVoucher: 'Ваучерді қабылдамаған өтініш берушілер',
    monitoring_columnParentIIN: 'Ата-ананың ЖСН',
    monitoring_columnChildIIN: 'Баланыӊ ЖСН',
    monitoring_columnParentFullName: 'Ата-ананың ТАӘ',
    monitoring_columnChildFullName: 'Баланыӊ ТАӘ',
    monitoring_columnBin: 'Оқу ұйымының БСН',
    monitoring_columnKatoCode:'Като коды',
    monitoring_columnLangName: 'Оқу ұйымының атауы',
    monitoring_columnParentTelephoneNumber: 'Ата-ананың телефон нөмірі',
    monitoring_fromDate: 'күні,бастап',
    monitoring_toDate: 'күні,дейін',
    monitoring_service: 'Қызметті таңдаңыз',
    monitoring_status: 'Мәртебені таңдаңыз',
    monitoring_chartsStatus: 'Мәртебелер бөлінісінде өтінімдер саны, бірлік',
    monitoring_chartsService: 'Қызметтер бөлінісіндегі өтінімдер саны, бірлік',
    monitoring_columnService: 'Атауы',
    monitoring_columnLocation: 'Аймақ',
    monitoring_columnSUBMITTED: 'Келіп түсті',
    monitoring_columnIN_PROGRESS: 'Өңделуде',
    monitoring_columnREADY_FOR_SIGN: 'Қолтаңба күтуде',
    monitoring_columnREADY_FOR_SIGN_POSITIVE: 'Оң жауап үшін қолтаңбаны күтуде',
    monitoring_columnREADY_FOR_SIGN_NEGATIVE: 'Теріс жауап үшін қолтаңбаны күтуде',
    monitoring_columnIN_PROGRESS_IN_EXTERNAL_APP: 'ББҰ АЖ-не берілді',
    monitoring_columnCOMPLETED_POSITIVE: 'Оң',
    monitoring_columnCOMPLETED_NEGATIVE: 'Теріс',
    monitoring_columnAllByRegion: 'Жалпы облыс бойынша',
    monitoring_columnAllByStatus: 'Жалпы мәртебе',
    monitoringDucks_errorLoadTable: 'Деректерді жүктеу мүмкін емес',
    monitoringDucks_errorExportTable: 'Деректерді экспорттау мүмкін болмады',
    monitoring_excelAllServices: 'Барлық қызметтер',
    monitoring_excelPeriod: 'Кезең: {{period.fromDate}} - {{period.toDate}}',
    monitoring_excelService: 'Қызметі: {{service}}',
    monitoring_excel_sheet_title: 'Есептер',
    monitoring_export_btn: 'Экспорттау',
    monitoring_report_btn: 'Есептерді жүктеу ',

    // queued
    monitoring_queued_byGender: 'Жыл және жынысы бойынша кезектегілер',
    monitoring_queued_byPosition: 'Аймақтық тиесілігі бойынша кезектегілер',
    age_suffix:'ж.',
    age_male:'ж.,ер бала',
    age_female:'ж., қыз бала',
    year_6_male: '6 жас, ер бала',
    year_6_female: '6 жас, қыз бала',
    year_5_male: '5 жас, ер бала',
    year_5_female: '5 жас, қыз бала',
    year_4_male: '4 жас, ер бала',
    year_4_female: '4 жас, қыз бала',
    year_3_male: '3 жас, ер бала',
    year_3_female: '3 жас, қыз бала',
    year_2_male: '2 жас, ер бала',
    year_2_female: '2 жас, қыз бала',
    year_1_male: '1 жас, ер бала',
    year_1_female: '1 жас, қыз бала',
    year_0_male: '0 жас, ер бала',
    year_0_female: '0 жас, қыз бала',
    from_2_to_6: '2 жастан 6 жасқа дейін',
    from_3_to_6: '3 жастан 6 жасқа дейін',

    region: 'Алматы облысының білім басқармасы',
    territorial_affiliation: 'Аумақтық тиесілігі',
    total: 'Барлығы',
    age_1: '1 жас',
    age_2: '2 жас',
    age_3: '3 жас',
    age_4: '4 жас',
    age_5: '5 жас',
    age_6: '6 жас',
    rural_area: 'ауылдық жер',
    urban_area: 'қалалық жер'
  }
});
